import { useContext } from "react";
import { EmailTemplateContext } from "../EmailTemplateContext";
import { ButtonElement } from "../elements/ButtonElement";
import { Plaintext } from "../elements/Plaintext";

export const NewJudgementAssignment = () => {
  const ctx = useContext(EmailTemplateContext);

  if (!ctx) return null;

  const {
    data,
    template: { template },
  } = ctx;

  return (
    <>
      <Plaintext template={template[1]!} innerRef={data.current[1]} />
      <Plaintext template={template[2]!} innerRef={data.current[2]} />
      <Plaintext template={template[3]!} innerRef={data.current[3]} />
      <ButtonElement template={template[4]!} innerRef={data.current[4]} />
      <Plaintext template={template[5]!} innerRef={data.current[5]} />
      {template[6]?.text && <Plaintext template={template[6]} innerRef={data.current[6]} />}
    </>
  );
};
